import { logError } from '@com-delta-idp/mnx-utils';
import {
  AEMErrorMessage,
  AEMpartner,
  CommonConstants,
  PartnersPersonalizationEngineResponse
} from '../../../models';
import {
  checkErrors,
  getEmptyContent,
  getImage,
  getLink,
  isValidData
} from '../../../utils';
import { Partner, Partners } from '../models';

export const getPartners = (
  skymiles: string | undefined,
  pe: PartnersPersonalizationEngineResponse | undefined,
  featureFlag: boolean | undefined,
  errors: (string | undefined)[],
  aemErrorMessages: AEMErrorMessage[] | undefined
): Partners => {
  try {
    if (checkErrors(errors, aemErrorMessages)) {
      return getEmptyContent<Partners>('partners', aemErrorMessages, true);
    }
    return isValidData<
      string,
      [
        string | undefined,
        PartnersPersonalizationEngineResponse | undefined,
        boolean | undefined
      ]
    >('', skymiles, pe, true)
      ? adaptPartners(
          featureFlag as boolean,
          skymiles as string,
          pe as PartnersPersonalizationEngineResponse
        )
      : getEmptyContent<Partners>();
  } catch (error) {
    logError(error as Error, 'SKYMILES', 'SHARED', 'PARTNERS');
    return getEmptyContent<Partners>('partners', aemErrorMessages, true);
  }
};

const adaptPartners = (
  featureFlag: boolean,
  skymiles: string,
  pe: PartnersPersonalizationEngineResponse
): Partners => {
  if (Object.keys(pe).length && featureFlag) {
    return {
      title: pe.contentDetails.parsys.partners.sectionTitle,
      action: getLink(
        pe.contentDetails.parsys.partners.viewAllPartnersLabel,
        pe.contentDetails.parsys.partners.viewAllPartnersCTA
      ),
      items: getPartnersList(pe.contentDetails.parsys.partners.partners),
      status: CommonConstants.EXIST,
      disabled: !featureFlag,
      loaded: true
    };
  } else {
    return getEmptyContent<Partners>('', [], true, true);
  }
};

export const getPartnersList = (rawPartners: string[]): Partner[] => {
  const partners: Partner[] = [];
  rawPartners.forEach((rawPartner: string) => {
    const aemPartner: AEMpartner = JSON.parse(rawPartner);
    partners.push({
      id: aemPartner.id,
      logo: getImage(aemPartner.logo, aemPartner.logoAltText),
      title: aemPartner.title,
      action: getLink(aemPartner.ctaLabel, aemPartner.ctaURL)
    });
  });
  return partners;
};
